import React from "react";
// import PageHeading from "../../Components/PageHeading/PageHeading";
import HowItWorksTab from "../HowItWorks/HowItWorksTab";
import { useNavigate } from "react-router-dom";
import PageHeading_V2 from "../../Components_V2/PageHeading/PageHeading";
import ContentComic from "../../Pages/Gallery/ContentComic";
import ContentConsultant from "../../Pages/Gallery/ContentConsultant";
import ContentText from "../../Pages/Gallery/ContentText";
import ContentImage from "../../Pages/Gallery/ContentImage";
import ContentNews from "../../Pages/Gallery/ContentNews";
import ContentPost from "../../Pages/Gallery/ContentPost";
import ContentTextVideo from "../../Pages/Gallery/ContentTextVideo";

const Contents = () => {
  const [tabValue, setTabValue] = React.useState(0);
  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const navigate = useNavigate();

  const data = [
    {
      category: "Social Media Consultant",
      items: [
        "Plan a social media marketing plan for a month",
        "Plan social media contents for a month using text and images",
        "Generate quotes for a month which can be used for social media",
      ],
    },
    {
      category: "Text AI",
      items: [
        "Ad from product description",
        "Grammatical Standard English",
        "Micro Horror Story Creator",
      ],
    },
    {
      category: "Image AI",
      items: [
        "Illustrate the concept of 'time travel' using everyday objects as your inspiration",
        "Depict a 'mermaid' composed entirely of household items found in a kitchen",
        "Imagine a 'floating city' made up of unconventional materials, like balloons, fruits, and umbrellas",
      ],
    },
    {
      category: "Post AI",
      items: ["Quote", "Mystery short story", "Soup Recipe"],
    },
    {
      category: "Text Video AI",
      items: [
        "The Silent Symphony: Exploring Nature's Harmonies",
        "Whispers of the Past: Uncovering Ancient Mysteries",
        "Journey Through Time: A Visual Odyssey of Human History",
      ],
    },
    {
      category: "News Video AI",
      items: ["Science and Technology", "World Middle East", "Entertainment"],
    },
    {
      category: "Comic Video AI",
      items: [
        "The Science of Sound Waves",
        "The Life Cycle of a Star",
        "The Story of the Wright Brothers",
      ],
    },
  ];

  const handleNavigate = () => {
    if (tabValue == 0) navigate('/ver2/comic-video-ai')
    else if (tabValue == 1) navigate('/ver2/consultant-ai')
    else if (tabValue == 2) navigate('/ver2/developer-ai')
    else if (tabValue == 3) navigate('/ver2/image-ai')
    else if (tabValue == 4) navigate('/ver2/news-video-ai')
    else if (tabValue == 5) navigate('/ver2/post-ai')
    else if (tabValue == 6) navigate('/ver2/text-ai')
    else if (tabValue == 7) navigate('/ver2/text-video-ai')
    else if (tabValue == 8) navigate('/ver2/toy-stories-ai')
    else if (tabValue == 9) navigate('/ver2/voice-ai')

  }

  return (
    <div>
      <PageHeading_V2 title="contents" />
      <div className="container account-container pb-3">

        <HowItWorksTab tabValue={tabValue} handleChangeTab={handleChangeTab} />

        <div
          // style={{ marginBlock: "20px", height: "200px", width: "100%" }}
          className="d-flex justify-content-center mt-2"
        >
          <button
            onClick={handleNavigate}
            className="btn btn-warning px-2 py-1">You can create similar contents. Click here.</button>
        </div>

        <div className="container mt-5">
          {tabValue === 0 && <ContentComic />}

          {tabValue === 1 && <ContentConsultant />}

          {tabValue === 2 && <ContentText />}

          {tabValue === 3 && <ContentImage />}

          {tabValue === 4 && <ContentNews />}

          {tabValue === 5 && <ContentPost />}

          {tabValue === 6 && <ContentText />}
          {tabValue === 7 && <ContentTextVideo />}
          {tabValue === 8 && <ContentText />}
          {tabValue === 9 && <ContentText />}

        </div>
      </div>
    </div>
  );
};

export default Contents;
